export enum PlatformDeclineType {
  /** Нарушение политики канала */
  VIOLATES_POLICY = 'violates_policy',

  /** Неполная информация */
  INCOMPLETE_INFORMATION = 'incomplete_information',

  /** Другое */
  OTHER = 'other',
}
